import React from 'react';
import { Box, FormControl, FormLabel, Input, Button, Typography } from '@mui/joy';
import VendorSelect from './VendorSelect';
import { today } from './MaterialForm';
import { inputSx, submitButtonSx } from './formCommon';

export const emptyDisposableForm = () => ({
  disposable_name: '',
  date_entered: today(),
  quantity: '',
  rate: '',
  vendor_id: ''
});

export const validateDisposableForm = (form) => {
  if (!form.disposable_name || !form.date_entered || !form.quantity || !form.vendor_id) {
    return 'All required fields must be filled';
  }
  if (form.vendor_id === '__add_new__') {
    return 'Please select a vendor or add one first';
  }
  if (parseInt(form.quantity, 10) <= 0) {
    return 'Quantity must be greater than 0';
  }
  return null;
};

export const disposableFormToPayload = (form) => ({
  disposable_name: form.disposable_name,
  date_entered: form.date_entered,
  quantity: parseInt(form.quantity, 10),
  rate: form.rate !== '' ? form.rate : null,
  vendor_id: parseInt(form.vendor_id, 10)
});

const DisposableForm = ({
  form,
  onChange,
  onSubmit,
  loading = false,
  vendors = [],
  vendorsLoading = false,
  onAddVendor,
  submitLabel = 'Add Disposable',
  fullWidthSubmit = true
}) => (
  <form onSubmit={onSubmit}>
    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Disposable Name</FormLabel>
      <Input
        name="disposable_name"
        value={form.disposable_name}
        onChange={onChange}
        required
        placeholder="Enter disposable name"
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Purchase Date</FormLabel>
      <Input type="date" name="date_entered" value={form.date_entered} onChange={onChange} required sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Quantity</FormLabel>
      <Input
        type="number"
        name="quantity"
        value={form.quantity}
        onChange={onChange}
        required
        min="1"
        placeholder="Enter quantity"
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Rate (per item)</FormLabel>
      <Input
        type="number"
        name="rate"
        value={form.rate}
        onChange={onChange}
        min="0"
        step="0.01"
        inputMode="decimal"
        placeholder="0.00"
        startDecorator={<Typography sx={{ color: 'text.tertiary', fontWeight: 500 }}>₹</Typography>}
        slotProps={{ input: { component: 'input' } }}
        sx={inputSx}
      />
    </FormControl>

    <VendorSelect
      vendors={vendors}
      value={form.vendor_id || ''}
      onChange={(vendorId) => onChange({ target: { name: 'vendor_id', value: vendorId } })}
      onAddNew={onAddVendor}
      loading={vendorsLoading}
      required
    />

    <Box sx={{ display: 'flex', justifyContent: fullWidthSubmit ? 'stretch' : 'flex-end', mt: 1 }}>
      <Button type="submit" loading={loading} fullWidth={fullWidthSubmit} sx={submitButtonSx}>
        {submitLabel}
      </Button>
    </Box>
  </form>
);

export default DisposableForm;
